/* @jsxImportSource react */

import type { InstallmentCalculatorLayouts } from '../../types';
import { Collapsed } from './Collapsed/Collapsed';
import { CompactAndColumn } from './CompactAndColumn/CompactAndColumn';

export interface InstallmentCalculatorSuspenseFallbackProps {
  calculatorLayout: InstallmentCalculatorLayouts;
}

export const InstallmentCalculatorSuspenseFallback = ({
  calculatorLayout,
}: InstallmentCalculatorSuspenseFallbackProps) =>
  calculatorLayout === 'Collapsible' ? <Collapsed /> : <CompactAndColumn />;
